// @flow

import { getBuyerToken } from '../index';
import type { Cookie } from './types';
import { getCookieValue } from './getCookieValue';
import { COOKIE_KEYS } from './constants';

export function getEmailTokenString(cookie: Cookie): string {
    return getCookieValue(cookie, COOKIE_KEYS.USER_EMAIL_TOKEN) || '';
}

//Info about token prefixes: https://github.com/1stdibs/necrodibsicon/blob/master/back-end/identity-service/tokens/Token_Updates.md
//Currently supporting old emailToken
export const isEmailOnlyUserToken = ({ userToken, emailToken } = {}) => {
    const emailOnlyTokenPrefixPattern = /\d+\_+m-/;
    return (
        (userToken && !!userToken.match(emailOnlyTokenPrefixPattern)) ||
        (!!emailToken && !userToken)
    );
};

export const isEmailOnly = (cookie: Cookie): boolean => {
    const { userToken, emailToken } = getBuyerToken(cookie);
    return isEmailOnlyUserToken({ userToken, emailToken });
};
